import "core-js/modules/es.array.join";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";

/**
 *@author   tonicli
 *@date     2016/6/5
 */
function F() {}

var _create = Object.create || function (proto) {
  F.prototype = proto;
  return new F();
};

function _toString(v) {
  return Object.prototype.toString.call(v);
}

function _isDate(v) {
  return _toString(v) === '[object Date]';
}

function _isFunc(v) {
  return _toString(v) === '[object Function]';
}

function _isObject(v) {
  return _toString(v) === '[object Object]';
}

function _isEmptyObject(v) {
  return _isObject(v) && !Object.keys(v).length;
}

var DEFAULT_FORMAT = 'Y-mm-dd H:i:s';
var _patternMap = {
  Y: function Y(d) {
    return d.getFullYear();
  },
  m: function m(d) {
    return d.getMonth() + 1;
  },
  mm: function mm(d) {
    return _pad(d.getMonth() + 1);
  },
  d: function d(_d) {
    return _d.getDate();
  },
  dd: function dd(d) {
    return _pad(d.getDate());
  },
  H: function H(d) {
    return _pad(d.getHours());
  },
  i: function i(d) {
    return _pad(d.getMinutes());
  },
  s: function s(d) {
    return _pad(d.getSeconds());
  }
};

function _pad(n) {
  return n > 9 ? n : "0".concat(n);
}

function _generatePatternReg(patternMap) {
  var patterns = [];
  var k;

  for (k in patternMap) {
    patterns.push(k);
  }

  patterns.sort(function (a, b) {
    return b.length - a.length;
  });
  return new RegExp("(".concat(patterns.join('|'), ")"), 'g');
}

function _mergePatternMap(patternMap) {
  var k;

  if (_isEmptyObject(patternMap)) {
    return _patternMap;
  }

  var map = _create(_patternMap);

  for (k in patternMap) {
    if (k.length !== 1) {
      throw new Error("[common.date._mergePatterns]invalid pattern key, pattern key must be only one char(".concat(k, ")"));
    }

    if (!_isFunc(patternMap[k])) {
      throw new Error("[common.date._mergePatterns]pattern value must be function(".concat(k, ")"));
    }

    map[k] = patternMap[k];
  }

  return map;
}

export function format(date, format, patternMap) {
  var dateObj;

  if (/^\d+$/.test(date)) {
    dateObj = new Date(parseInt(date));
  } else if (typeof date === 'string') {
    dateObj = new Date(date.replace(/-/g, '/'));
  } else if (_isDate(date)) {
    dateObj = date;
  }

  if (!dateObj || dateObj.toString() === 'Invalid Date') {
    throw new Error("[common.date.format]the input cannot be converted to date object(".concat(date, ")"));
  }

  format = format || DEFAULT_FORMAT;
  patternMap = patternMap && _isObject(patternMap) ? _mergePatternMap(patternMap) : _patternMap;
  return format.replace(_generatePatternReg(patternMap), function (k) {
    if (_isFunc(patternMap[k])) {
      return patternMap[k](dateObj);
    }

    return k;
  });
}
export default {
  format: format
};